import React, { Suspense, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik } from 'formik';
import ErrorBox, { noError } from '../../common/components/ErrorBox';
import { createNews } from '../api/news.api';
import { mutate } from 'swr';
import { NewsForm, validateForm } from '../components/NewsForm';
import { LoadingSpinner } from '../../common/components/LoadingSpinner';
import { UserContext } from '../../common/context/userContext';
import { PageFrame } from '../../common/components/PageFrame';

export const AddNewsPage = () => {
  const history = useHistory();
  const [error, setError] = useState(noError);
  const { user } = useContext(UserContext);

  const handleSubmit = async (values) => {
    try {
      await createNews(values);
      await mutate('/portal/news');
      history.push('/news/list');
    } catch (e) {
      console.log(e);
      setError({
        title: 'An error occurred saving this news item',
        msg: 'Please try again',
      });
    }
  };

  return (
    <PageFrame title="Add News">
      <Formik
        initialValues={{
          productIds: [],
          countryIds: [],
          productTypeIds: [],
          createdBy: user.name,
        }}
        validate={validateForm}
        onSubmit={handleSubmit}
      >
        <Suspense fallback={<LoadingSpinner />}>
          <NewsForm />
        </Suspense>
      </Formik>
      <ErrorBox
        title={error.title}
        msg={error.msg}
        onClose={() => setError(noError)}
      />
    </PageFrame>
  );
};
